import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface DeleteConfirmDialogProps {
  open: boolean;
  itemNames: string[];
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteConfirmDialog = ({ open, itemNames, onClose, onConfirm }: DeleteConfirmDialogProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  const description = itemNames.length === 1 ?
    `Are you sure you want to delete "${itemNames[0]}"? This cannot be undone.` :
    `Are you sure you want to delete ${itemNames.length} items? This cannot be undone.`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Delete
        {itemNames.length === 1 ? 'item' : 'items'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="outlined"
          color="error"
          disabled={isSubmitting}
          onClick={() => { void handleConfirm(); }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
